import { useState } from "react";
import PropTypes from "prop-types";
import { StyledSelectableUpperUnits, StyledUpperUnitsInfo } from "../../../styles/StyledSelectableUpperUnits/StyledSelectableUpperUnits";
import { QueryLoader } from "../../Loader";
import { default as SelectableRadioPerson } from "./SelectableRadioPerson";

export default function SelectableSinglePeople({ data, isLoading, isError, error, setSelectedPersonID }) {
	const [selectedPerson, setSelectedPerson] = useState();

	const onChangeValue = (event) => {
		setSelectedPerson(event.target.value);
		setSelectedPersonID(event.target.value);
	};

	return isError ? (
		<p>{error}</p>
	) : isLoading ? (
		<StyledUpperUnitsInfo>
			<QueryLoader />
		</StyledUpperUnitsInfo>
	) : data.length > 0 ? (
		<StyledSelectableUpperUnits onChange={onChangeValue}>
			{data.map((el) => (
				<SelectableRadioPerson key={el.id} selectedPerson={selectedPerson} data={el} value={el.id.toString()} />
			))}
		</StyledSelectableUpperUnits>
	) : (
		<StyledUpperUnitsInfo>
			<p>No people found</p>
		</StyledUpperUnitsInfo>
	);
}

SelectableSinglePeople.propTypes = {
	data: PropTypes.array,
	isLoading: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	isError: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	error: PropTypes.string,
	setSelectedPersonID: PropTypes.func,
};
